import React from 'react'
import classNames from 'classnames'
import { Link, matchPath } from 'react-router-dom'
import LayoutRightFillIcon from 'remixicon-react/LayoutRightFillIcon'
import { IMenu } from '@utils/constants/menu/index'
import { NAVIGATION_POSTION } from '@utils/constants'
import { LOCALSTORAGE_KEYS } from '@features/General'
import Logo from '@components/Layouts/Logo'
import useMenu from '@hooks/component/useMenu'
import { useSelector } from 'react-redux'
import { RootState } from '@store/store'
import styles from './index.scss'

function TopbarMenu() {
    const { menus } = useMenu()
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const isMatch = React.useCallback(
        path =>
            matchPath(location.pathname, {
                path,
                exact: false,
                strict: false
            }),
        [location]
    )

    return (
        <>
            <div className={styles['menu']}>
                <div
                    className={styles['menu-item']}
                    onClick={() => {
                        localStorage.setItem(LOCALSTORAGE_KEYS.NAVIGATION_POSTION, NAVIGATION_POSTION.SIDE)
                        location.reload()
                    }}
                    title={i18n?.Dashboard?.Switch_Menu}
                >
                    <LayoutRightFillIcon size={20} />
                </div>

                <div className={styles['dynamic-menu']}>
                    {menus.map((item: IMenu, index: number) => {
                        if (!item.hide && item?.permission !== false) {
                            return (
                                <Link
                                    to={item.path}
                                    key={index}
                                    className={classNames(styles['menu-item'], {
                                        [styles.active]: isMatch(item.path)
                                    })}
                                >
                                    {item.title}
                                </Link>
                            )
                        }
                    })}
                </div>
            </div>
            <div className={styles['top-navigation__logo']}>
                <Logo />
            </div>
        </>
    )
}

export default TopbarMenu
